"use client"
import { CarouselNavigationArrows } from "./CarouselNavigationArrows"
import { CarouselNavigationDots } from "./CarouselNavigationDots"
import { CarouselThumbs } from "./CarouselNavigationThumbs"

export const CarouselNavigation = Object.assign(
  {},
  {
    Arrows: CarouselNavigationArrows,
    Thumbs: CarouselThumbs,
    Dots: CarouselNavigationDots,
  },
)
